import { TimerPauseOutlineIcon } from './TimerPauseOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 7C566FCC-EC47-409A-8E7B-5769C82CEF01
 * name timer-pause-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-pause-outline.svg
 * tags
 * - Date / Time 
 */
export const StopwatchPauseOutlineIcon = TimerPauseOutlineIcon;
export default StopwatchPauseOutlineIcon